import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

export const interceptor: HttpInterceptorFn = (req, next) => {
  const global = inject(GlobalService);
  const router = inject(Router);
    const spinner = inject(NgxSpinnerService);
    const toaster = inject(ToastrService);


  const token = global.token;
  
  

  let headers: any = {
    Authorization: token ? `Bearer ${token}` : ''
  };

  if (!(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const authReq = req.clone({ setHeaders: headers });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        router.navigate(["auth/login"]);
        toaster.info('Your session has expired. please Login again')
        spinner.hide();
      }
      return throwError(() => error);
    })
  );
};
